var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDarkwebShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1784 3H15.8815C15.8815 8.62948 11.318 13.1931 5.68848 13.1931V23.3162C5.68848 43.6325 26.0047 49 26.0047 49C26.0047 49 46.3209 43.6325 46.3209 23.3162V13.1931C40.6915 13.1931 36.1278 8.62948 36.1278 3H30.593",
    fill: "url(#paint0_linear_7240_24309)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4059 36.0747L34.1979 36.1867V34.9441C35.2806 34.1921 35.8032 32.8481 35.4779 31.5467L34.5072 27.6321C34.2886 26.7361 33.6486 26.0001 32.8006 25.6587L30.9126 24.8961C30.6886 24.8054 30.5552 24.5761 30.5819 24.3361C30.6032 24.1494 30.7259 23.9894 30.8966 23.9147C30.9712 23.8401 31.3126 23.4401 31.7872 21.8721C31.7392 21.1627 30.7632 20.6934 30.1712 20.4801C29.0939 20.0854 27.5739 19.8614 26.0006 19.8614C22.8059 19.8614 20.2939 20.7414 20.2139 21.8667C20.6832 23.4401 21.0299 23.8401 21.1046 23.9147C21.2752 23.9894 21.3979 24.1494 21.4192 24.3361C21.4459 24.5761 21.3126 24.8054 21.0886 24.8961L19.2006 25.6587C18.3526 26.0001 17.7126 26.7361 17.4939 27.6321L16.5232 31.5467C16.1979 32.8481 16.7206 34.1921 17.8032 34.9441V36.1867L17.5952 36.0747C15.8886 35.1467 15.0192 33.1787 15.4886 31.2907L16.4539 27.3761C16.7579 26.1494 17.6379 25.1414 18.8006 24.6667L19.9952 24.1867C19.7126 23.7067 19.4352 23.0027 19.1579 22.0747C18.6886 20.4801 19.9206 17.8454 21.3446 15.9361C22.0806 14.9547 24.0059 12.6667 26.0006 12.6667C27.9952 12.6667 29.9206 14.9547 30.6566 15.9361C32.0806 17.8454 33.3126 20.4801 32.8432 22.0747C32.5659 23.0027 32.2886 23.7067 32.0059 24.1867L33.2006 24.6667C34.3632 25.1414 35.2432 26.1494 35.5472 27.3761L36.5126 31.2907C36.9819 33.1787 36.1126 35.1467 34.4059 36.0747Z",
    fill: "#3773B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8064 36.1228C18.6677 36.3841 18.3424 36.4801 18.0864 36.3361L17.8037 36.1868V34.9441C17.8997 35.0134 18.001 35.0774 18.1077 35.1361L18.593 35.4028C18.8544 35.5414 18.9504 35.8668 18.8064 36.1228Z",
    fill: "#44464A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1976 34.9441V36.1868L33.9149 36.3361C33.8349 36.3841 33.7496 36.4001 33.6642 36.4001C33.4722 36.4001 33.2909 36.2988 33.1949 36.1228C33.0509 35.8668 33.1469 35.5414 33.4082 35.4028L33.8936 35.1361C34.0002 35.0774 34.1016 35.0134 34.1976 34.9441Z",
    fill: "#44464A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6721 21.68C30.5815 23.9253 28.6188 26.3733 26.0001 26.3733C23.3815 26.3733 21.4135 23.92 21.3281 21.6693C21.7335 21.3813 23.3495 20.928 26.0001 20.928C27.4561 20.928 28.8428 21.0773 29.8028 21.3386C30.2935 21.472 30.5495 21.6 30.6721 21.68Z",
    fill: "#3773B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3183 38.8001C35.3183 39.0934 35.0836 39.3334 34.7849 39.3334H17.2169C16.9183 39.3334 16.6836 39.0934 16.6836 38.8001C16.6836 38.5014 16.9183 38.2668 17.2169 38.2668H17.8889C17.8409 38.1121 17.8036 37.9468 17.8036 37.7761V28.7788C17.8036 27.9201 18.5023 27.2214 19.3609 27.2214H32.6409C33.4996 27.2214 34.1983 27.9201 34.1983 28.7788V37.7761C34.1983 37.9468 34.1609 38.1121 34.1129 38.2668H34.7849C35.0836 38.2668 35.3183 38.5014 35.3183 38.8001Z",
    fill: "url(#paint1_linear_7240_24309)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_24309",
    x1: 26,
    y1: 50.5,
    x2: 22.3512,
    y2: 2.27608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFD79C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_24309",
    x1: 26.0009,
    y1: 27.2214,
    x2: 26.0009,
    y2: 39.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6883B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A45ABE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDarkwebShield);
export default __webpack_public_path__ + "static/media/icon_darkweb_shield.7c09609e3832f492bc023ee47d42c9fe.svg";
export { ForwardRef as ReactComponent };